import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

/** baseURL 既可直接给字符串，也可给取值函数（延迟到真正发请求时再解析）。 */
type BaseURLSource = string | (() => string | undefined) | undefined;

/**
 * 说明：本模块处在一条循环依赖上——
 *   各业务 api 模块 → services/request → @umijs/max →（测试产物）app.tsx → 各业务 api 模块
 * 业务 api 模块普遍在顶层执行 `const request = createAppRequest()`，
 * 所以本模块的所有导出都必须是「函数声明」（会被提升），且不得在顶层读取
 * BizAppConfig / umiRequest：否则循环回到这里时会命中暂时性死区或 undefined。
 * 配置与 umi request 一律延迟到请求真正发出时再取。
 */
export function createRequest(baseURL?: BaseURLSource) {
  return <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const scopedBaseURL =
      (typeof baseURL === 'function' ? baseURL() : baseURL) ??
      BizAppConfig.appApiUrl ??
      '';
    return (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
  };
}

export function createAppRequest() {
  return createRequest(() => BizAppConfig.appApiUrl);
}

export function createTenantManagementRequest() {
  return createRequest(() => BizAppConfig.appTenantManagementUrl);
}
